import { useCommon } from './useCommon.js'
const { cachedAxiosGet } = useCommon()

export const useGetData = (devDomains) => {
  const siteDomain = devDomains?.site || 'https://site.weathernews.jp'
  const getSideMenuList = async () => {
    try {
      const { data } = await cachedAxiosGet(`${siteDomain}/site/global_header/side_menu_list.json`)
      return data
    } catch (error) {
      return []
    }
  }

  const getSnsList = async () => {
    try {
      const { data } = await cachedAxiosGet(`${siteDomain}/site/global_header/sns_menu_list.json`)
      return data
    } catch (error) {
      return []
    }
  }

  const getMemberList = async () => {
    try {
      const { data } = await cachedAxiosGet(`${siteDomain}/site/global_header/member_menu_list.json`)
      return data
    } catch (error) {
      return []
    }
  }

  const getPrefTable = async () => {
    try {
      const { data } = await cachedAxiosGet(`${siteDomain}/site/onebox/json/pref_button_table.json`)
      return data
    } catch (error) {
      return []
    }
  }

  const getNewsList = async () => {
    try {
      const { data } = await cachedAxiosGet('https://mws.cdn.weathernews.jp/s/topics/json/rec_ch_zero.json')
      return data
    } catch (error) {
      return []
    }
  }

  return { getSideMenuList, getSnsList, getMemberList, getPrefTable, getNewsList }
}
